<template>
  <div class="sp_registerFoot">
    <p class="sp_login_copyRight">Sangfor Official WebsiteSangfor Community Copyright 2021 SANGFOR TECHNOLOGIES INC.</p>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped lang="scss">
</style>